import React from "react"

import CostAnalysis from "@/onboarding/features/cost_analysis/Season"
import Slice, {
  LAST_SELECTED_AWARD_SET_ID_PATH,
  LAST_SELECTED_BIDDING_REGION_ID_PATH,
} from "@/onboarding/features/cost_analysis/Slice"
import { withApp } from "@/components/App"

const App = ({ season }): JSX.Element => (
  <CostAnalysis
    season={season}
    selectedBiddingRegionId={window.localStorage.getItem(LAST_SELECTED_BIDDING_REGION_ID_PATH)}
    selectedAwardSetId={window.localStorage.getItem(LAST_SELECTED_AWARD_SET_ID_PATH)}
  />
)

export default withApp(App, { slices: [Slice] })
